import accountSettingEn from './accountSetting.json';
import accountTerminationEn from './accountTermination.json';
import appTerminationEn from './appTermination.json';
import barcodeEn from './barcode.json';
import boardEn from './board.json';
import cartEn from './cart.json';
import commonEn from './common.json';
import couponEn from './coupon.json';
import customerServiceEn from './customerService.json';
import easyCardEn from './easyCard.json';
import errorsEn from './errors.json';
import eventEn from './event.json';
import giftEn from './gift.json';
import inquiryEn from './inquiry.json';
import itemEn from './item.json';
import itemsEn from './items.json';
import linkEn from './link.json';
import mainEn from './main.json';
import noticeEn from './notice.json';
import notificationEn from './notification.json';
import orderEn from './order.json';
import orderLogEn from './orderLog.json';
import orderLogsEn from './orderLogs.json';
import orderReceiptEn from './orderReceipt.json';
import permissionEn from './permission.json';
import pointEn from './point.json';
import prepaidCardEn from './prepaidCard.json';
import shopDetailEn from './shopDetail.json';
import shopListEn from './shopList.json';
import shopLocationEn from './shopLocation.json';
import shopPrepareEn from './shopPrepare.json';
import signInEn from './signIn.json';
import signUpEn from './signUp.json';
import stampEn from './stamp.json';
import termDetailEn from './termDetail.json';
import tierEn from './tier.json';

const en = {
    accountSetting: accountSettingEn,
    accountTermination: accountTerminationEn,
    appTermination: appTerminationEn,
    barcode: barcodeEn,
    board: boardEn,
    cart: cartEn,
    common: commonEn,
    coupon: couponEn,
    stamp: stampEn,
    point: pointEn,
    prepaidCard: prepaidCardEn,
    customerService: customerServiceEn,
    easyCard: easyCardEn,
    errors: errorsEn,
    event: eventEn,
    gift: giftEn,
    inquiry: inquiryEn,
    item: itemEn,
    items: itemsEn,
    link: linkEn,
    main: mainEn,
    notice: noticeEn,
    notification: notificationEn,
    order: orderEn,
    orderLog: orderLogEn,
    orderLogs: orderLogsEn,
    orderReceipt: orderReceiptEn,
    permission: permissionEn,
    shopDetail: shopDetailEn,
    shopList: shopListEn,
    shopLocation: shopLocationEn,
    shopPrepare: shopPrepareEn,
    signIn: signInEn,
    signUp: signUpEn,
    termDetail: termDetailEn,
    tier: tierEn,
};

export default en;
